module.exports = __webpack_public_path__ + "img/addEnclosureWhite.63d0ae54.svg";